// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71381883","239":"a2ee1c23","488":"6de421d4","501":"8e9ce344","667":"05d80e28"}[chunkId] + ".chunk.js";
};